document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.product-grid');
  if (!grid) return;

  const items = [...grid.querySelectorAll('.product-grid__item')];
  if (!items.length) return;

  // Solo ordenar en la colección de event-tickets
  if (!window.location.pathname.includes('event-tickets')) return;

  items.sort((a, b) => {
    const dateA = a.querySelector('time')?.getAttribute('datetime') || '';
    const dateB = b.querySelector('time')?.getAttribute('datetime') || '';
    return new Date(dateA) - new Date(dateB);
  });

  items.forEach(item => grid.appendChild(item));
});